const rawApiBaseUrl =
  process.env.REACT_APP_API_BASE_URL || "https://asgarpourgold.ir/EzzatKhah/Back/public";

export const API_BASE_URL = rawApiBaseUrl.replace(/\/+$/, "");

export function apiUrl(path = "") {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}
